<template>
    <div class="afu-border afu-border-t-0 afu-border-l-0 afu-border-r-0 afu-border-b-1 afu-border-solid afu-border-neutral afu-pb-7">
        <h3 class="afu-text-4xl afu-text-secondary afu-mb-2 afu-font-semibold">
            {{ $_seekerFieldByCode('change_email').label || $t('account.change_email') }}
        </h3>

        <p
            class="afu-text-black afu-mb-7"
            v-html="$t('account.change_email_info')"
        />

        <C1Alert
            v-if="!!emailResponse.message"
            :variant="emailResponse.variant"
        >
            <div><strong>{{ emailResponse.message_title }}</strong></div>
            <span v-html="emailResponse.message" />
        </C1Alert>

        <div class="md:afu-w-1/2">
            <C1FormGroup>
                <C1FormInput
                    id="email"
                    :label="$t('label.email_address')"
                    label-for="email"
                    v-model="email"
                    name="email"
                    :placeholder="$t('label.enter_new_email')"
                    :disabled="$_seekerFieldByCode('change_email').read_only"
                    @keyup.enter="updateEmail()"
                />
            </C1FormGroup>

            <C1FormGroup>
                <C1FormInput
                    id="password"
                    :label="$t('label.enter_current_password_for_email')"
                    label-for="password"
                    type="password"
                    v-model="password"
                    :placeholder="$t('label.enter_current_password')"
                    :disabled="$_seekerFieldByCode('change_email').read_only"
                    @keyup.native.enter="updateEmail()"
                />
            </C1FormGroup>

            <div class="afu-text-danger-400 afu-mb-2">
                {{ error }}
            </div>

            <C1Button
                :disabled="loader.update_email || $_seekerFieldByCode('change_email').read_only"
                :is-busy="loader.update_email"
                variant="outline-secondary"
                @click="updateEmail()"
            >
                {{ $t('label.change_email') }}
            </C1Button>
        </div>
    </div>
</template>

<script>
    import has from 'lodash/has';
    import { mapState, mapActions, mapGetters } from 'vuex';
    import C1Button from '@/components/C1Components/C1Button';
    import C1Alert from '@/components/C1Components/C1Alert';
    import C1FormInput from '@/components/C1Components/C1FormInput';
    import C1FormGroup from '@/components/C1Components/C1FormGroup';

    export default {
        name: 'SettingUpdateEmail',

        components: {
            C1FormGroup,
            C1FormInput,
            C1Alert,
            C1Button,
        },

        $_veeValidate: {
            validator: 'new',
        },

        data() {
            return {
                email: '',
                password: '',
                emailResponse: {
                    message_title: '',
                    message: '',
                    variant: '',
                },
                loader: {
                    update_email: false,
                },
                error: '',
            };
        },

        computed: {
            ...mapState({
                $_apiMessage: state => state.apiMessage,
            }),
            ...mapGetters('site', {
                $_seekerFieldByCode: 'seekerFieldByCode',
            }),
        },

        methods: {
            ...mapActions('me', {
                $_updateMyEmail: 'updateMyEmail',
            }),

            async updateEmail() {
                this.error = '';

                if (this.email === '') {
                    this.error = 'Email is required';
                    return;
                }

                if (this.password === '') {
                    this.error = 'Password is required';
                    return;
                }

                if (this.form?.end_date === '' && this.form?.is_current == false) {
                    this.error = 'End date is required';
                    return;
                }

                const data = {
                    email: this.email,
                    password: this.password,
                };

                this.loader.update_email = true;
                this.$_updateMyEmail(data)
                    .then(() => {
                        this.emailResponse.message_title = '';
                        this.emailResponse.message = 'Account verification sent';
                        this.emailResponse.variant = 'success';
                    })
                    .catch(error => {
                        const errorCode = has(error, 'response.data.error')
                            ? error.response.data.error
                            : 'ServerErrorException';
                        this.emailResponse.message_title = 'Email failed';
                        this.emailResponse.message = this.$_apiMessage[errorCode];
                        this.emailResponse.variant = 'danger';
                    })
                    .finally(() => {
                        this.loader.update_email = false;
                    });
            },
        },
    };
</script>
